import React from 'react'
import './App.css';
import { Route, Routes, BrowserRouter } from "react-router-dom";

import Home from './components/Home/Home';

import Header from './components/Common/Header/Header'
import Footer from './components/Common/Footer/Footer'

import Login from './components/Login/Login';
import Aboutus from './components/Aboutus/Aboutus';
import Privacy from './components/Privacy/Privacy';
import Terms from './components/Terms/Terms';
import Refund from './components/Refund/Refund';
import Contactus from './components/Contactus/Contactus';
import Delivery from './components/Delivery/Delivery';


const App = () => {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} ></Route>
        <Route path="/login" element={<Login />} ></Route>
        <Route path="/aboutus" element={<Aboutus />} ></Route>
        <Route path="/privacy" element={<Privacy />} ></Route>
        <Route path="/terms" element={<Terms />} ></Route>
        <Route path="/refund" element={<Refund />} ></Route>
        <Route path="/contactus" element={<Contactus />} ></Route>
        <Route path="/delivery" element={<Delivery />} ></Route>
      </Routes>
      <Footer />
    </BrowserRouter>
  )
}

export default App